import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import {namespace} from 'vuex-class'
const uiModule = namespace('ui')

@Component({})
export default class BaseListItem extends Vue {
  @Prop(String) title!: string
  @Prop(Array) data!: object[]
  @Prop(Boolean) isDraggable!: false
  @uiModule.Getter('isLoadingGetter') isLoading: boolean

  get isEmpty() {
    if (this.data) {
      const isEmpty = this.data.length === 0
      return isEmpty
    } else {
      return false
    }
  }
}
